import * as React from "react";
import {api} from "../../../api/api";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import HistoricalJobImport from "../../../model/historicalJobImport/HistoricalJobImport";
import DateUtils from "../../../utils/DateUtils";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";

interface ComponentProps {
	items: HistoricalJobImport[];
}

interface ComponentState {
	downloadingReports: { [key: string]: boolean };
}

export default class HistoricalJobImportsTable extends React.PureComponent<ComponentProps, ComponentState> {

	constructor(props: ComponentProps) {
		super(props);
		this.state = {downloadingReports: {}};
	}

	render() {
		return (
			<table className="l-table-default table-hover">
				<thead>
				<tr>
					<th>ID</th>
					<th>Status</th>
					<th>Date</th>
					<th>Total Rows</th>
					<th>Success</th>
					<th>Skipped</th>
					<th>Failed</th>
					<th>Error Report</th>
				</tr>
				</thead>
				<tbody>
				{this.props.items.map((item, index) =>
					<tr key={item.importId || index}>
						<td>{item.importId}</td>
						<td>{item.status.replaceUnderscoresWithSpaces()}</td>
						<td>{item.createdAt ? item.createdAt.format(DateUtils.DATE_TIME_FORMAT) : "-"}</td>
						<td>{item.totalRows === null ? "-" : item.totalRows}</td>
						<td>{item.processedRows}</td>
						<td>{item.skippedRows}</td>
						<td>{item.failedRows}</td>
						<td>{this.renderErrorReportCell(item)}</td>
					</tr>)}
				</tbody>
			</table>
		);
	}

	private renderErrorReportCell(item: HistoricalJobImport) {
		if (!item.errorReportAvailable) {
			return "Not available";
		}

		return (
			<ButtonPrimary
				label={"Download report"}
				disabled={!!this.state.downloadingReports[item.importId]}
				isLoading={!!this.state.downloadingReports[item.importId]}
				onClick={() => this.downloadErrorReport(item.importId)}
			/>
		);
	}

	private downloadErrorReport(importId: string) {
		const downloadWindow = window.open("", "_blank");
		this.setState(prevState => ({
			downloadingReports: {
				...prevState.downloadingReports,
				[importId]: true
			}
		}), () => api.instance.historicalJobImportApi.getErrorReportUrl(importId)
			.then((url) => {
				if (downloadWindow) {
					downloadWindow.location.href = url;
				}
				else {
					window.location.assign(url);
				}
				this.stopDownload(importId);
			})
			.catch((error) => {
				if (downloadWindow) {
					downloadWindow.close();
				}
				this.stopDownload(importId);
				notifyBugsnagAndShowToast(error, "Historical jobs report download", "Cannot download error report");
			}));
	}

	private stopDownload(importId: string) {
		this.setState(prevState => {
			const downloadingReports = {...prevState.downloadingReports};
			delete downloadingReports[importId];
			return {downloadingReports};
		});
	}
}
